module.exports = __webpack_public_path__ + "img/rad-conv-gen-4.ba0994aa.png";